import React from 'react';
// 1. Import ChartJS and the ArcElement
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend
} from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import LoadingBars from '../../elements/LoadingBars';
import { DOUGHNUT_COLOR, DOUGHNUT_LABEL, getChartOptions } from './constants';
import styles from './styles.scoped.css';
import PropTypes from 'prop-types';

// 2. Register the elements
ChartJS.register(ArcElement, Tooltip, Legend);

function DoughnutChartMonitoring({ data, isLoading }) {
  return (
    <>
      {isLoading ? (
        <div className={styles['loading-container']}>
          <LoadingBars size={10} />
        </div>
      ) : (
        <Doughnut
          data={{
            labels: [
              DOUGHNUT_LABEL.REGISTRASI_BERHASIL,
              DOUGHNUT_LABEL.SUDAH_ONBOARDING,
              DOUGHNUT_LABEL.SUDAH_TRANSAKSI
            ],
            datasets: [
              {
                data: [
                  data?.registered || 0,
                  data?.onboarding || 0,
                  data?.transaction || 0
                ],
                backgroundColor: [
                  DOUGHNUT_COLOR.REGISTRASI_BERHASIL,
                  DOUGHNUT_COLOR.SUDAH_ONBOARDING,
                  DOUGHNUT_COLOR.SUDAH_TRANSAKSI
                ],
                borderColor: '#ffffff',
                borderWidth: 3,
              },
            ],
          }}
          options={getChartOptions()}
        />
      )}
    </>
  );
}

// Fixed PropTypes definition (using .shape)
DoughnutChartMonitoring.propTypes = {
  data: PropTypes.shape({
    registered: PropTypes.number,
    onboarding: PropTypes.number,
    transaction: PropTypes.number,
  }),
  isLoading: PropTypes.bool
};

export default DoughnutChartMonitoring;
